import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const Overlay = styled.div({
	position: 'absolute',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	backgroundColor: token('color.background.neutral.subtle.hovered', colors.N0),
	opacity: 0.8,
	content: "''",
});
